var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "applt-decoration-page" }, [
    _c(
      "div",
      { staticClass: "decoration-page" },
      [
        _c(
          "el-card",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: {
              "element-loading-text": _vm.loadingText,
              "element-loading-spinner": "el-icon-loading",
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "header",
                attrs: { slot: "header" },
                slot: "header",
              },
              [
                _c("div", [_vm._v("页面名称")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini", plain: "" },
                        on: { click: _vm.close },
                      },
                      [_vm._v("关闭")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini", plain: "" },
                        on: { click: _vm.previewH5 },
                      },
                      [_vm._v("预览")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.save(2)
                          },
                        },
                      },
                      [_vm._v("发布")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.save(1)
                          },
                        },
                      },
                      [_vm._v("保存")]
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "container" }, [
              _c(
                "div",
                { staticClass: "components" },
                [
                  _c("div", { staticClass: "head-title flex" }, [
                    _c("div", { staticClass: "dot" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "title-text" }, [
                      _vm._v("基础组件"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.library, function (com) {
                    return _c(
                      "div",
                      { key: com.title, staticClass: "com-item" },
                      [
                        _c(
                          "div",
                          { staticClass: "list", attrs: { draggable: "true" } },
                          _vm._l(com.components, function (item, index) {
                            return _c(
                              "div",
                              {
                                key: item.key,
                                staticClass: "list-item",
                                class: {
                                  dragstart: _vm.libraryIndex === index,
                                },
                                attrs: { draggable: "true" },
                                on: {
                                  click: function ($event) {
                                    return _vm.addComponent(item, index)
                                  },
                                  dragstart: function (e) {
                                    return _vm.libraryDragstart(e, index, item)
                                  },
                                  dragend: _vm.libraryDragend,
                                },
                              },
                              [
                                _c("div", { staticClass: "icon-box" }, [
                                  item.formKey == "carouselForm"
                                    ? _c("img", {
                                        attrs: {
                                          src: require("../../../../assets/imgs/skin/banner.png"),
                                          alt: item.title,
                                        },
                                      })
                                    : item.formKey == "navListForm"
                                    ? _c("img", {
                                        attrs: {
                                          src: require("../../../../assets/imgs/skin/nav.png"),
                                          alt: item.title,
                                        },
                                      })
                                    : item.formKey == "searchForm"
                                    ? _c("img", {
                                        attrs: {
                                          src: require("../../../../assets/imgs/skin/search.png"),
                                          alt: item.title,
                                        },
                                      })
                                    : item.formKey == "arrangeImagesForm"
                                    ? _c("img", {
                                        attrs: {
                                          src: require("../../../../assets/imgs/skin/imgList.png"),
                                          alt: item.title,
                                        },
                                      })
                                    : item.formKey == "hotspotForm"
                                    ? _c("img", {
                                        attrs: {
                                          src: require("../../../../assets/imgs/skin/imgAct.png"),
                                          alt: item.title,
                                        },
                                      })
                                    : item.formKey == "goodsForm"
                                    ? _c("img", {
                                        attrs: {
                                          src: require("../../../../assets/imgs/skin/goodsList.png"),
                                          alt: item.title,
                                        },
                                      })
                                    : item.formKey == "marketgoodsForm"
                                    ? _c("img", {
                                        attrs: {
                                          src: require("../../../../assets/imgs/skin/goodsList.png"),
                                          alt: item.title,
                                        },
                                      })
                                    : item.formKey == "pintuanForm"
                                    ? _c("img", {
                                        attrs: {
                                          src: require("../../../../assets/imgs/skin/goodsList.png"),
                                          alt: item.title,
                                        },
                                      })
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "item-title" }, [
                                  _vm._v(_vm._s(item.title)),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "preview scroll-view" }, [
                _c("div", { staticClass: "preview-iphone" }, [
                  _c(
                    "div",
                    {
                      ref: "iphoneRef",
                      staticClass: "iphone",
                      style: {
                        backgroundColor: _vm.form.isBgColor
                          ? _vm.form.bgColor || ""
                          : "",
                        backgroundImage: _vm.form.isBgImg
                          ? "url(" + (_vm.form.bgImg || "") + ")"
                          : "",
                        color: _vm.form.isTextColor ? _vm.form.textColor : "",
                      },
                      attrs: { "data-dragBox": "iphone", draggable: "false" },
                      on: {
                        dragover: _vm.dragover,
                        dragend: _vm.dragend,
                        drop: _vm.drop,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "page-title flex",
                          staticStyle: { "justify-content": "space-between" },
                        },
                        [
                          _c("i", { staticClass: "el-icon-arrow-left" }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.form.title || "页面标题")),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticStyle: { color: "transparent" } }, [
                            _vm._v("i"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.form.componentList, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: item.key + index,
                            ref: "previewItemRefs",
                            refInFor: true,
                            staticClass: "preview-item",
                            class: {
                              active: index === _vm.previewIndex,
                              dragstart: _vm.dragStartIndex === index,
                              dragging: _vm.dragging === index,
                            },
                            attrs: { draggable: "true" },
                            on: {
                              click: function ($event) {
                                return _vm.previewItemClick(index)
                              },
                              dragstart: function (e) {
                                return _vm.dragstart(e, index)
                              },
                              dragend: _vm.dragend,
                              dragover: _vm.dragover,
                              dragenter: function (e) {
                                return _vm.handleDragenter(e, index)
                              },
                              drop: function (e) {
                                return _vm.handleDrop(e, index)
                              },
                            },
                          },
                          [
                            _c("MyComponent", {
                              attrs: {
                                componentKey: item.key,
                                propsData: item,
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: index === _vm.previewIndex,
                                    expression: "index === previewIndex",
                                  },
                                ],
                                staticClass: "btns",
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-delete",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.deleteComponent(index)
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                index !== 0
                                  ? _c("i", {
                                      staticClass: "el-icon-top",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return (function (e) {
                                            return _vm.sortComponent(
                                              e,
                                              index,
                                              -1
                                            )
                                          })($event)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                index !== _vm.form.componentList.length - 1
                                  ? _c("i", {
                                      staticClass: "el-icon-bottom",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return (function (e) {
                                            return _vm.sortComponent(
                                              e,
                                              index,
                                              1
                                            )
                                          })($event)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "setPage scroll-view" }, [
                _c("div", { staticClass: "head-title flex" }, [
                  _c("div", { staticClass: "dot" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex" }, [
                    _c(
                      "div",
                      {
                        class: [
                          "title-text",
                          _vm.settingKey == 1 && "active-head",
                        ],
                        staticStyle: { "margin-right": "20px" },
                        on: {
                          click: function ($event) {
                            return _vm.changeSetting(1)
                          },
                        },
                      },
                      [_vm._v("页面设置")]
                    ),
                    _vm._v(" "),
                    _vm.form.componentList[_vm.previewIndex] &&
                    _vm.form.componentList[_vm.previewIndex].title
                      ? _c(
                          "div",
                          {
                            class: [
                              "title-text",
                              _vm.settingKey == 2 && "active-head",
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.changeSetting(2)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.form.componentList[_vm.previewIndex].title
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "margin-top": "30px", height: "100%" } },
                  [
                    _c("PageConfigVue", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.settingKey == 1,
                          expression: "settingKey==1",
                        },
                      ],
                      ref: "pageConfigVueRef",
                      on: { updatePageConfig: _vm.updatePageConfig },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.settingKey == 2,
                            expression: "settingKey==2",
                          },
                        ],
                      },
                      [
                        _c("div", { staticClass: "page-form" }, [
                          _vm.form.componentList[_vm.previewIndex]
                            ? _c(
                                "div",
                                { staticClass: "page-form-item" },
                                _vm._l(
                                  _vm.form.componentList,
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      { key: item.formKey + index },
                                      [
                                        _c("MyComponent", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: index === _vm.previewIndex,
                                              expression:
                                                "index === previewIndex",
                                            },
                                          ],
                                          key: item.formKey + index,
                                          staticClass: "form-content",
                                          attrs: {
                                            componentKey: item.formKey,
                                            propsData: item,
                                            updateForm: function (data) {
                                              return _vm.updateForm(data, index)
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("SkinPreview", { ref: "SkinPreviewRef" }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }